import { render } from "./ClientForm.vue?vue&type=template&id=290be034&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"

import "./ClientForm.vue?vue&type=style&index=0&id=290be034&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290be034"]])

export default __exports__